// extracted by css-extract-rspack-plugin
module.exports =  {"root":"EmptyTaskList__root___ZP17I","title":"EmptyTaskList__title___bPeFH","description":"EmptyTaskList__description___vdYlC"};